<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <TableUsuarios :aguardando="aguardando"/>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import TableUsuarios from '@/router/views/admin/components/table-usuarios'
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Usuários",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    TableUsuarios
  },
  props: {
    aguardando: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      title: "Usuários",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Usuários',
          active: true,
        },
      ],
    };
  },
};
</script>


